import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">
                俺去也
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              深受用户喜爱的娱乐内容平台，提供海量高清视频资源、极速播放体验，无需注册即可免费观看，每日持续更新。
            </p>
          </div>

          <div>
            <h4 className="text-base font-heading font-bold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading font-bold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  免责声明
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading font-bold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-mail-line mt-0.5 text-background-300"></i>
                <span>contact@anquye.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-customer-service-line mt-0.5 text-background-300"></i>
                <span>在线客服：7×24小时</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5 text-background-300"></i>
                <span>中国·北京</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-[1280px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 俺去也 - 版权所有 | 娱乐内容聚合平台
            </p>
            <p className="text-xs text-background-500">
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="hover:text-background-300 transition-colors"
              >
                京ICP备2024XXXXXXXX号
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}